import {
  ADS_CAMPAIGN_MEDIA_FROM_LINKEDIN_POST,
  LINKEDIN_PUBLISH_AS,
} from "../utils/constants";

const AD_FORMAT_IMAGE = "STANDARD_UPDATE";
const AD_FORMAT_VIDEO = "SINGLE_VIDEO";
const AD_FORMAT_CAROUSEL = "CAROUSEL";
const AD_FORMAT_DOCUMENT = "SPONSORED_UPDATE_NATIVE_DOCUMENT";

export const extractLinkedInOrgIdFromReference = (reference = "") => {
  if (!reference) return "";
  const match = reference.match(/urn:li:organization:(.+)/);
  return match ? match[1] : "";
};

export const buildLinkedInPageAccountOption = ({
  page,
  integrationID,
  advertiserIds = [],
}) => {
  const orgId = String(page.id);
  const organizationUrn =
    page.organizationUrn || `urn:li:organization:${orgId}`;
  const orgUrn = extractLinkedInOrgIdFromReference(organizationUrn);

  return {
    id: orgId,
    name: page.name || orgId,
    integrationID,
    publishAs: LINKEDIN_PUBLISH_AS.ORGANIZATION,
    orgUrn,
    organizationUrn,
    displayLabel: page.name || orgId,
    isPage: true,
    pageId: orgId,
    advertiserIds,
  };
};

export const getLinkedInPageAccountsForAdvertiser = ({
  integration,
  integrationID = "",
  adAccountID,
}) => {
  if (!integration || !adAccountID) return [];

  const resolvedIntegrationID = integrationID || integration?.id || "";
  const advertiser = integration.advertisers?.[adAccountID];
  if (!advertiser?.reference) return [];

  const advertiserReference = advertiser.reference;
  const advertiserOrgId =
    extractLinkedInOrgIdFromReference(advertiserReference);
  const pages = Object.values(integration.pages || {});

  const matched = pages
    .filter((page) => {
      const orgId = String(page.id);
      const organizationUrn =
        page.organizationUrn || `urn:li:organization:${orgId}`;

      return (
        organizationUrn === advertiserReference ||
        extractLinkedInOrgIdFromReference(organizationUrn) === advertiserOrgId
      );
    })
    .map((page) =>
      buildLinkedInPageAccountOption({
        page,
        integrationID: resolvedIntegrationID,
        advertiserIds: [adAccountID],
      })
    );

  if (matched.length > 0) {
    return matched;
  }

  const displayName = advertiser.pageName || advertiserOrgId || adAccountID;
  return [
    {
      id: advertiser.id || adAccountID,
      name: displayName,
      integrationID: resolvedIntegrationID,
      publishAs: LINKEDIN_PUBLISH_AS.ORGANIZATION,
      orgUrn: advertiserOrgId,
      organizationUrn: advertiserReference,
      displayLabel: displayName,
      isPage: true,
      pageId: advertiserOrgId,
      advertiserIds: [adAccountID],
    },
  ];
};

export const getLinkedInGalleryItemKey = (item) => {
  if (!item) return "";
  return item.postId || item.postID || item.id || "";
};

export const normalizeLinkedInGalleryItem = (media = {}) => {
  const postId = media.postId || media.postID || "";
  // Card preview uses url/thumbnail only; downloadUrl is reserved for storage upload.
  const displayUrl = media.url || media.thumbnailUrl || "";

  return {
    ...media,
    from: media.from || ADS_CAMPAIGN_MEDIA_FROM_LINKEDIN_POST,
    postId,
    postID: postId || media.postID,
    id: postId || media.id,
    url: displayUrl,
  };
};

export const isLinkedInPostAd = ({ isPostAd = false, mediaData = [] }) => {
  if (isPostAd) return true;

  const firstMedia = mediaData?.[0];
  return (
    firstMedia?.from === ADS_CAMPAIGN_MEDIA_FROM_LINKEDIN_POST &&
    Boolean(firstMedia?.postID)
  );
};

export const getIsOnPostDestinationLinkedin = ({ isPostAd = false }) => {
  return isPostAd === true;
};

export const getIsPostAdVisibleLinkedin = ({ adFormat }) => {
  return adFormat === AD_FORMAT_IMAGE || adFormat === AD_FORMAT_VIDEO;
};

export const getLinkedInPostStorageSourceUrl = ({
  mediaType,
  url,
  downloadUrl,
}) => {
  const isVideo = String(mediaType || "").toUpperCase() === "VIDEO";
  if (isVideo) {
    if (!downloadUrl) return null;
    return downloadUrl;
  }
  return url;
};

export const getLinkedInPostMediaTypeFilter = ({ adFormat }) => {
  if (adFormat === AD_FORMAT_IMAGE) return "IMAGE";
  if (adFormat === AD_FORMAT_VIDEO) return "VIDEO";
  if (adFormat === AD_FORMAT_CAROUSEL) return "CAROUSEL";
  if (adFormat === AD_FORMAT_DOCUMENT) return "DOCUMENT";
  return null;
};
